/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const disableMonitoringIntegrationBodyExpectedVersionExclusiveMin = 0;
export const disableMonitoringIntegrationBodyExpectedVersionMax = 9007199254740991;

export const DisableMonitoringIntegrationBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(disableMonitoringIntegrationBodyExpectedVersionExclusiveMin)
    .max(disableMonitoringIntegrationBodyExpectedVersionMax),
});

export type DisableMonitoringIntegrationBody = zod.input<typeof DisableMonitoringIntegrationBody>;
export type DisableMonitoringIntegrationBodyOutput = zod.output<
  typeof DisableMonitoringIntegrationBody
>;
